var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHobbies({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_1926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 23.4001V0.600061H0.6V23.4001H23.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_1926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6653 11.3344C21.1334 11.3338 21.5934 11.4572 21.9985 11.692V6.00155H16.3081C16.5428 5.59648 16.6662 5.1365 16.6657 4.66832C16.6657 3.19572 15.4719 2.00194 13.9992 2.00194C12.5266 2.00194 11.3329 3.19572 11.3329 4.66832C11.3323 5.1365 11.4557 5.59648 11.6905 6.00155H6.00002V11.692C5.59496 11.4572 5.13499 11.3338 4.66683 11.3344C3.19419 11.3344 2.0004 12.5281 2.0004 14.0008C2.0004 15.4734 3.19419 16.6672 4.66683 16.6672C5.13499 16.6677 5.59496 16.5443 6.00002 16.3096V22H11.6905C11.4557 21.5949 11.3323 21.1349 11.3329 20.6668C11.3329 19.1942 12.5266 18.0004 13.9992 18.0004C15.4719 18.0004 16.6657 19.1942 16.6657 20.6668C16.6662 21.1349 16.5428 21.5949 16.3081 22H21.9985V16.3096C21.5934 16.5443 21.1334 16.6677 20.6653 16.6672C19.1927 16.6672 17.9989 15.4734 17.9989 14.0008C17.9989 12.5281 19.1927 11.3344 20.6653 11.3344Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbies);
export default __webpack_public_path__ + "static/media/hobbies.4142036b6eb6e69617e48186a2e83388.svg";
export { ForwardRef as ReactComponent };